module.exports = "/_next/static/images/6637ba992290a45a29b75f3718b1292e-man-with-cellphone-lg@1x.jpg.webp";